export default "__VITE_ASSET__Cova4iCr__"